module.exports = __webpack_public_path__ + "img/img11.b4f19b89.svg";